import { Middleware } from 'redux';
import { ItemActionTypes } from '../reducers/Item/types';
import { UserActions } from '../reducers/User/actions';

export const activeMarketSyncMiddleware: Middleware = store => next => action => {
  const result = next(action);
  if (
    action.type === ItemActionTypes.PLACE_ITEM_BID_SUCCESS ||
    action.type === ItemActionTypes.PLACE_ITEM_ASK_SUCCESS ||
    action.type === ItemActionTypes.UPDATE_ITEM_BID_SUCCESS ||
    action.type === ItemActionTypes.UPDATE_ITEM_ASK_SUCCESS ||
    action.type === ItemActionTypes.DELETE_ITEM_BID_SUCCESS ||
    action.type === ItemActionTypes.DELETE_ITEM_ASK_SUCCESS
  ) {
    store.dispatch(UserActions.getUserActiveMarket());
  }

  return result;
}; 